import { NotificationManager } from "react-notifications";
import { httpPost } from "../helpers/httpMethods";
import { hideLoader, showLoader } from "../helpers/loader";

// Free papers open straight away (owner, 2026-10-29): no pop-up. The reader needs the same ₦0 subscription the old
// free-read dialog created, so this makes that exact call (POST /subscribe) quietly and opens the edition.
// Only for papers that are always free (isPaid === false); "free until" papers keep the normal flow.
export async function openFree({ publicationId, editionId, history, alreadyHasAccess }) {
  const open = () => history.push(editionId ? `/view_single_paper/${editionId}` : `/view_paper/${publicationId}`);
  if (alreadyHasAccess) return open();
  showLoader();
  const r = await httpPost("subscribe", { publicationId });
  hideLoader();
  const msg = r && r.er ? String(r.er.message || r.er) : "";
  if (r && (r.code === 201 || r.success || /active subscription already/i.test(msg))) return open();
  NotificationManager.error(msg || "We couldn’t open this paper. Please try again.");
  return undefined;
}
